import _ from '../Manager'
import Sesiones from './Sesiones'

class App {
    ses= new Sesiones({
        inicio: '10:00',
        duracion: 60,
        contador: 18
    })

    start(){
        console.log('starting....')
        if ( _.getAuthToken() ) _.open('Bowling')
        else _.open('Login')
    }

    get sesiones(){
        return this.ses.sesiones;
    }

}

export default new App()